<template>
	<div class="modal fade" ref="modal" data-backdrop="static">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Paciente</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-4">
							Matricula
							<input
								v-model="form.mat"
								type="number"
								class="form-control"
							/>
						</div>
						<div class="col-sm-8">
							Nome
							<input
								v-model="form.nome"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							Sexo
							<select v-model="form.sexo" class="form-control">
								<option value="M">Mascilino</option>
								<option value="F">Feminino</option>
							</select>
						</div>
						<div class="col-sm-4">
							Nascimento
							<input
								v-model="form.nasc"
								type="date"
								class="form-control"
							/>
						</div>
						<div class="col-sm-6">
							Empresa
							<select v-model="form.empresa" class="form-control">
								<option
									v-for="(empresa, index) in assets.empresas"
									:key="index"
									:value="empresa.cod"
								>
									{{ empresa.title }}
								</option>
							</select>
						</div>
						<div class="col-sm-6">
							Unidade
							<select v-model="form.unidade" class="form-control">
								<option
									v-for="(unidade, index) in assets.unidades"
									:key="index"
									:value="unidade.cod"
								>
									{{ unidade.title }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-default pull-left"
						@click="closeMd"
					>
						<i class="fa fa-close"></i> Cancelar
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:disabled="!is_valid()"
						@click="save"
					>
						<i class="fa fa-save"></i> Cadastrar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import { clone } from 'lodash';
	import toastr from 'toastr';

	const reset = {
		mat: '',
		nome: '',
		sexo: 'M',
		nasc: '',
		empresa: '',
		unidade: '',
	};

	export default {
		inject: ['assets'],
		data() {
			return {
				form: clone(reset),
			};
		},
		methods: {
			is_valid() {
				return this.form.mat != '' && this.form.nome != '';
			},
			save() {
				WBS.send('private-save-sd2000Patients', this.form, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Colaborador cadastrado com sucesso');
						this.closeMd();
						this.$emit('update', this.form.mat);
					} else {
						toastr.error('Erro ao cadastrar solicitação');
						console.log(resp);
					}
				});
			},
			open() {
				this.form = clone(reset);
				this.form.empresa = this.assets.empresas[0].cod;
				this.form.unidade = this.assets.unidades[0].cod;
				$(this.$refs.modal).modal('show');
			},
			closeMd() {
				$(this.$refs.modal).modal('hide');
				setTimeout((r) => $('body').addClass('modal-open'), 400);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/entradas/components/mdCreatePatient.vue